import { createContext, useContext } from 'react';
import { TableAction, TableAsyncActions, TableSyncActions } from './actions';
import { TableState } from './types';

const contextErrorMessage = 'useTable must be used within a TableProvider';

export interface TableContextProps<T = any> extends TableAsyncActions, TableSyncActions {
  state: TableState<T>;
  dispatch: React.Dispatch<TableAction>;
}

export const TableContext = createContext<TableContextProps | undefined>(undefined);

export const useTable = <T = any>() => {
  const context = useContext(TableContext);
  if (context === undefined) {
    throw new Error(contextErrorMessage);
  }
  return context as TableContextProps<T>;
};

export const useTableActions = () => {
  const context = useContext(TableContext);
  if (context === undefined) {
    throw new Error(contextErrorMessage);
  }

  const {
    state,
    dispatch,
    ...actions
  } = context;

  return actions;
};
